import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import * as api from "../../api/index";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Form, FormElement } from "@progress/kendo-react-form";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { useUploadForm } from "components/fileUploadHook";
import MattersCombobox from "../Postings/MattersComboBox";
import { onFileUpload } from "services/fileDataService";
import { FILES_CONTEXT, useFiles } from "services/filesDownloadService";
import MatterAccount from "../MatterLedger/MatterAccount";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import useMediaQuery from "hooks/useMediaQuery";
import {
  updateCurrentUserSettings,
  useCurrentUserSettings,
} from "services/userSettingsService.js";
import MattersTimeRecords from "./BillMatterPopupGrid";
import styles from "./Bills.module.scss";
import BillGrid from "./BillGrid";
import MattersDisbRecords from "./BillDisbPopupGrid";
import BillProfitCostGrid from "./BillProfitCostGrid";
import BillFixedHeadersGrid from "./BillFixedFeePopup";
import { getMattersBalances } from "actions/matters.action";
import SearchComboBox from "components/common/SearchComboBox";
import MatterDetails from "pages/MatterLedger/MatterDetails";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { TransactionPeriod } from "components/common/TransactionPeriod";
import { getMatterDefaults } from "api";
import { toast } from "react-toastify";
import BillExpenseGrid from "./BillExpenseGrid";
import ReportViewer from "pages/Reports/ReportViewerComponent";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";
import { ReportURL } from "api/axios.config";
import ConfirmationDialog from "components/common/ConfirmationDialog";
import QuickPostings from "components/QuickPosting";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { IoIosAddCircle } from "react-icons/io";
import SettingsIcon from "assets/common/setting-icon.svg";
import PrinterIcon from "assets/common/print-icon.svg";
import { AmountFormat } from "components/common/formatter";
import BillDetailsModal from "components/Bills/BillDetailsModal";
import BillSettingsDialog from "components/Bills/BillSettingsDialog";
import { getLookups } from "api/accountsAPI";
import { IoClose, IoMenu } from "react-icons/io5";
import { BiSolidDownArrow } from "react-icons/bi";
import SubmitButton from "components/common/SubmitButton";
import { useActiveFeeEarner } from "services/userService";

const USER_SETTING_MATTER_DETAILS_EXPANDED_KEY = "BillsMatterDetailsExpanded";
const GUID_EMPTY = "00000000-0000-0000-0000-000000000000";

const refOrBillNo = (ref, billNo) =>
  (ref != null && String(ref).trim() !== "" ? String(ref).trim() : null) ??
  billNo ??
  "*Bill No*";

const toMatterValue = (value) => {
  if (!value) return null;

  return {
    matterId: value.matterId ?? value.matterID,
    matterRef: value.matterRef ?? "",
    feeEarnerRef: value.feeEarnerRef,
    feeEarnerName: value.feeEarnerName ?? "",
    details: value.details ?? "",
  };
};

const isBlank = (value) => String(value ?? "").trim() === "";

const Bills = (props) => {
  const matches = useMediaQuery("(min-width: 1200px)");
  const dispatch = useDispatch();
  const { data: userSettings } = useCurrentUserSettings();
  const formId =
    props.component === "BillingRequest" ? "billingRequestForm" : "billForm";
  const date = new Date();
  const [details, setDetails] = useState("");
  const [matterName, setMatterName] = useState("");
  const [reference, setReference] = useState("*Bill No*");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [matterDefaults, setMatterDefaults] = useState(null);
  const [rejectBillingRequestDialog, setRejectBillingRequestDialog] =
    useState(false);
  const [rate, setRate] = useState("");
  const [initialData, setInitialData] = useState();
  const [showBillDetailsModal, setShowBillDetailsModal] = useState(false);
  const [showBillSettingsDialog, setShowBillSettingsDialog] = useState(false);
  const [selectedBillReportResourceId, setSelectedBillReportResourceId] =
    useState(null);
  const [billDetailsLookups, setBillDetailsLookups] = useState([]);
  const [showDetailsDropdown, setShowDetailsDropdown] = useState(false);

  const [nominalVatValue, setNominalVatValue] = useState({
    nominalRef: "",
    vatCode: "",
    feeEarnerRef: "",
  });
  const [showForm, setshowForm] = useState(false);
  const [showDisbForm, setshowDisbForm] = useState(false);
  const [dateselector, setdateselector] = useState(date);
  const [matterRef, setmatterref] = useState(null);
  const [resetGrd, setResetGrid] = useState(false);
  const [billTimeData, setBillTimeData] = useState([]);
  const [feeEarner, setFeeEarner] = useState(null);
  const { data: activeFeeEarners = [] } = useActiveFeeEarner();
  const [loadingData, setLoadingData] = useState(false);
  const [billDisbData, setBillDisbData] = useState([]);
  const [reportPreviewData, setReportPreviewData] = useState(false);
  const [totalValues, setTotalValues] = useState({
    totalAmount: 0,
    totalVat: 0,
  });
  const [timeTotals, setTimeTotals] = useState({
    totalAmount: 0,
    totalVat: 0,
  });
  const [disbTotals, setDisbTotals] = useState({
    totalAmount: 0,
    totalVat: 0,
  });
  const [expenseTotals, setExpenseTotals] = useState({
    totalAmount: 0,
    totalVat: 0,
  });
  const [showExpenseGrid, setShowExpenseGrid] = useState(false);
  const [addNewDisb, setAddNewDisb] = useState(false);
  const [shoWProfitGrid, setShowProfitGrid] = useState(false);
  const [showTemplatesGrid, setShowTemplatesGrid] = useState(false);
  const [matterTimeRecords, setMatterTimeRecords] = useState([]);
  const [matterDisbRecords, setMatterDisbRecords] = useState([]);
  const [matterBalanceClear, setMatterBalanceClear] = useState(true);
  const [error, setError] = useState(undefined);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [materDetailsExpanded, setMaterDetailsExpanded] = useState(() => {
    const savedSetting = userSettings?.find(
      (s) => s.key === USER_SETTING_MATTER_DETAILS_EXPANDED_KEY,
    )?.value;
    return savedSetting === "true" || savedSetting === true || false;
  });
  const [isExpansionLoading, setIsExpansionLoading] = useState(false);
  const { isSuccess, uploadForm, progress } = useUploadForm();

  const TRANSACTION_PERIOD = JSON.parse(
    sessionStorage.getItem("sessionPeriod"),
  )?.period;

  const [filesData, setFilesData] = useState([]);
  const PRE_SELECTED_MATTER =
    props.component === "BillingRequest" && props.selectedMatter;
  const POST_BILLING_REQUEST =
    props.component === "BillRequest" && props.billingRequestPayload;

  const { files: filesCurrentData, clearDisbursementFiles } = useFiles(
    FILES_CONTEXT.BILL,
  );

  const editableRef = React.useRef(null);
  const appliedBillRequestIdRef = React.useRef(null);

  useEffect(() => {
    const savedSetting = userSettings?.find(
      (s) => s.key === USER_SETTING_MATTER_DETAILS_EXPANDED_KEY,
    )?.value;
    if (savedSetting !== undefined) {
      setMaterDetailsExpanded(savedSetting === "true" || savedSetting === true);
    }
  }, [userSettings]);

  useEffect(() => {
    calculateTotalValues();
    // Calculate totals from time and disb records
    const timeTotal = {
      totalAmount: 0,
      totalVat: 0,
    };
    if (matterTimeRecords[0] !== undefined) {
      matterTimeRecords.forEach((item) => {
        const netAmount =
          item.billedNetAmount === "w/o"
            ? 0
            : typeof item.billedNetAmount === "number"
              ? item.billedNetAmount
              : item.value || 0;
        timeTotal.totalAmount += netAmount;
        timeTotal.totalVat += item.billVat || 0;
      });
    }
    setTimeTotals(timeTotal);

    const disbTotal = {
      totalAmount: 0,
      totalVat: 0,
    };
    const expenseTotal = {
      totalAmount: 0,
      totalVat: 0,
    };
    if (matterDisbRecords[0] !== undefined) {
      matterDisbRecords.forEach((item) => {
        if (item.type === "Expense") {
          expenseTotal.totalAmount += item.netAmount || 0;
          expenseTotal.totalVat += item.vatAmount || 0;
        } else {
          disbTotal.totalAmount += item.netAmount || 0;
          disbTotal.totalVat += item.vatAmount || 0;
        }
      });
    }
    setDisbTotals(disbTotal);
    setExpenseTotals(expenseTotal);
  }, [matterDisbRecords, matterTimeRecords]);

  const onChangeFeeEarner = (event) => {
    setFeeEarner(event?.value);
  };

  const onRejectBill = async () => {
    try {
      setIsSubmitting(true);
      await api.rejectBillingReqeust(props.billingRequestPayload?.billRequestId);
      props.onClose();
      toast.success("Bill Rejected");
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const getMatterDefaultsData = async (id) => {
    try {
      const data = await getMatterDefaults(id);
      setMatterDefaults(data?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangematter = (e) => {
    let event = e.value;
    setMatterBalanceClear(false);

    // Clear grid data when matter changes
    setMatterTimeRecords([]);
    setMatterDisbRecords([]);
    setBillTimeData([]);
    setBillDisbData([]);

    if (event !== null) {
      setLoadingData(true);
      setSelectedBillReportResourceId(null);
      dispatch(getMattersBalances(event.matterId, "Bills"));
      getMatterDefaultsData(event?.matterId);
      setmatterref(event);
      setMatterName(event.matterRef);
      if (event.feeEarnerRef) {
        setFeeEarner({
          display: `${event?.feeEarnerRef?.userRef || event?.feeEarnerRef} - ${
            event?.feeEarnerRef?.displayname ||
            event?.feeearner?.displayname ||
            event?.feeEarnerName ||
            ""
          }`,
          userRef: event?.feeEarnerRef || event?.feeEarnerRef?.userRef,
        });
      } else {
        setFeeEarner(null);
      }
      setTimeout(() => {
        setLoadingData(false);
      }, 1000);
    } else {
      setmatterref(null);
      setSelectedBillReportResourceId(null);
      setMatterBalanceClear(true);
    }
  };
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  const calculateTotalValues = () => {
    let amount = {
      totalAmount: 0,
      totalVat: 0,
    };
    if (matterTimeRecords[0] !== undefined) {
      matterTimeRecords.forEach((item) => {
        const netAmount =
          item.billedNetAmount === "w/o"
            ? 0
            : typeof item.billedNetAmount === "number"
              ? item.billedNetAmount
              : item.value || 0;
        amount.totalAmount += netAmount;
        amount.totalVat += item.billVat || 0;
      });
    }
    if (matterDisbRecords[0] !== undefined) {
      matterDisbRecords.forEach((item) => {
        amount.totalAmount += item.netAmount || 0;
        amount.totalVat += item.vatAmount || 0;
      });
    }
    setTotalValues(amount);
  };

  const preparePostingData = (values) => {
    let amount = {
      totalAmount: 0,
      totalVat: 0,
    };

    if (matterTimeRecords[0] !== undefined) {
      matterTimeRecords.forEach((item) => {
        const netAmount =
          item.billedNetAmount === "w/o"
            ? 0
            : typeof item.billedNetAmount === "number"
              ? item.billedNetAmount
              : item.value || 0;
        amount.totalAmount += netAmount;
        amount.totalVat += item.billVat || 0;
      });
    }

    if (matterDisbRecords[0] !== undefined) {
      matterDisbRecords.forEach((item) => {
        amount.totalAmount += item.netAmount || 0;
        amount.totalVat += item.vatAmount || 0;
      });
    }

    const data = [
      {
        postingType: "Bill",
        matterID: matterRef?.matterId,
        date: dateselector,
        reference: refOrBillNo(
          reference,
          POST_BILLING_REQUEST && props.billingRequestPayload?.billNo,
        ),
        details: details ?? "",
        netAmount: parseFloat((amount.totalAmount || 0).toFixed(2)),
        vatAmount: parseFloat((amount.totalVat || 0).toFixed(2)),
        feeEarnerRef: feeEarner?.userRef,
        transactionPeriod: TRANSACTION_PERIOD,
        fcCurrencyCode: "GBP",
      },
    ];

    if (billTimeData[0] !== undefined) {
      const billTime = [];
      const billProfitCost = [];
      billTimeData.forEach((item) => {
        if (item.type !== "ProfitCost") {
          billTime.push({
            ...item,
            vatCode: nominalVatValue?.vatCode?.vatCodeId || item?.vatCode,
            nominalRef: item?.nominalRef,
            feeEarnerRef:
              item.feeEarnerRef?.userRef ?? item.feeEarnerRef ?? feeEarner?.userRef,
          });
        } else {
          billProfitCost.push({
            ...item,
            feeEarnerRef:
              item.feeEarnerRef?.userRef ?? item.feeEarnerRef ?? feeEarner?.userRef,
          });
        }
      });
      data[0].billTime = billTime;
      data[0].billProfitCost = billProfitCost;
    }

    if (billDisbData[0] !== undefined) {
      const billDisb = [];
      const billExpenses = [];
      billDisbData.forEach((item) => {
        if (item.type === "Expense") {
          billExpenses.push({ ...item });
        } else {
          billDisb.push({ ...item });
        }
      });
      data[0].billDisb = billDisb;
      data[0].billExpenses = billExpenses;
    }

    if (filesCurrentData[0] !== undefined) {
      data[0].DocumentFiles = filesCurrentData.map((item) => item.fileID);
    }

    data[0].billDisb = data[0].billDisb?.length > 0 ? data[0].billDisb : undefined;
    data[0].billExpenses =
      data[0].billExpenses?.length > 0 ? data[0].billExpenses : undefined;

    const billReportResourceId =
      selectedBillReportResourceId ?? matterDefaults?.defaultBillResourceId;
    if (billReportResourceId && billReportResourceId !== GUID_EMPTY) {
      data[0].billTemplateResourceId = billReportResourceId;
    }

    return data;
  };

  const setStateFromApiResponse = (responseData, setStates) => {
    const data = responseData; // Extract first object since it's an array

    setStates.setMatterTimeRecords((prevData) => [
      ...prevData,
      ...(data.billProfitCost
        ? data.billProfitCost.map((item) => ({
          ...item,
          type: "ProfitCost",
          value: item?.netAmount,
          billVat: item.vatAmount,
        }))
        : []),
    ]);

    setStates.setMatterTimeRecords((prevData) => [
      ...prevData,
      ...(data.billTime
        ? data.billTime.map((item) => ({
          ...item,
          value: item?.netAmount,
          billVat: item.vatAmount,
        }))
        : []),
    ]);

    setStates.setBillTimeData((prevData) => [
      ...prevData,
      ...(data.billTime
        ? data.billTime.map((item) => ({
          ...item,
          value: item?.netAmount,
          billVat: item.vatAmount,
        }))
        : []),
    ]);

    setStates.setBillDisbData(data.billDisb ? [...data.billDisb] : []);
    setStates.setMatterDisbRecords(
      data.billExpenses
        ? data?.billExpenses?.map((item) => ({ ...item, type: "Expense" }))
        : [],
    );

    setStates.setMatterDisbRecords((prevData) => [
      ...prevData,
      ...(data.billDisb ? data.billDisb.map((item) => ({ ...item })) : []),
    ]);

    setStates.setFilesCurrentData(
      data.DocumentFiles ? data.DocumentFiles.map((fileID) => ({ fileID })) : [],
    );
  };

  const handleSubmit = async (values) => {
    const data = preparePostingData(values);

    if (!data) return; // Stop execution if validation fails
    if (
      data[0]?.matterID === undefined ||
      data[0]?.feeEarnerRef === undefined ||
      isBlank(data[0]?.details) ||
      isBlank(data[0]?.reference)
    ) {
      setError(true);
      return;
    }

    if (POST_BILLING_REQUEST)
      data[0].billRequestId = props.billingRequestPayload?.billRequestId;

    try {
      setIsSubmitting(true);
      let response;
      if (props.component === "BillingRequest") {
        response = await api.createBillingRequest(data[0]);
        toast.success(
          `Posted Bill Request - ${response?.data?.data?.billRequestId}`,
        );
        props.onSubmitSuccess?.();
        if (props.isDialog) {
          props.onClose?.();
        }
      } else {
        response = await api.createposting(data);
        toast.success(
          `Posted Successfully for ${response?.data?.data[0]?.postingType} - ${response?.data?.data[0]?.transactionNo}`,
        );
      }
      setTotalValues({ totalAmount: 0, totalVat: 0 });
      setMatterDisbRecords([]);
      setInitialData({ feeEarnerRef: "" });
      reset();
      if (POST_BILLING_REQUEST) {
        props.onPostSuccess?.();
        props.onClose();
      }
      setMatterBalanceClear(true);
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const reset = () => {
    setDetails("");
    updateEditableContent("");
    setReference("*Bill No*");
    setRate("");
    setMatterTimeRecords([]);
    setResetGrid(!resetGrd);
    setError(false);
    calculateTotalValues();
    clearDisbursementFiles();
  };

  useEffect(() => {
    if (PRE_SELECTED_MATTER) {
      onChangematter({ value: toMatterValue(props.selectedMatter) });
    } else if (POST_BILLING_REQUEST) {
      const payload = props.billingRequestPayload;
      onChangematter({ value: toMatterValue(payload) });
      setStateFromApiResponse(payload, {
        setMatterTimeRecords,
        setMatterDisbRecords,
        setBillTimeData,
        setBillDisbData,
        setFilesCurrentData: setFilesData,
      });
    }

    fetchBillDetailsLookups();
  }, []);

  useEffect(() => {
    if (!POST_BILLING_REQUEST || !props.billingRequestPayload) {
      appliedBillRequestIdRef.current = null;
      return;
    }
    const p = props.billingRequestPayload;
    const id = p.billRequestId ?? p.billNo ?? "single";
    if (appliedBillRequestIdRef.current === id) return;
    appliedBillRequestIdRef.current = id;

    setReference(refOrBillNo(p.reference, p.billNo));
    const d = p.details ?? "";
    setDetails(d);
    requestAnimationFrame(() => {
      if (editableRef.current) editableRef.current.textContent = d;
    });
    const feRef =
      typeof p.feeEarnerRef === "string" ? p.feeEarnerRef : p.feeEarnerRef?.userRef;
    if (feRef?.length && activeFeeEarners.length) {
      const fe = activeFeeEarners.find((x) => x.userRef === feRef);
      if (fe) setFeeEarner(fe);
    }
  }, [POST_BILLING_REQUEST, props.billingRequestPayload, activeFeeEarners]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDetailsDropdown) {
        const target = event.target;
        const isDropdownClick = target.closest(".bill-details-dropdown");
        const isButtonClick = target.closest(".bill-details-dropdown-button");
        if (!isDropdownClick && !isButtonClick) {
          setShowDetailsDropdown(false);
        }
      }
    };

    if (showDetailsDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDetailsDropdown]);

  const fetchBillDetailsLookups = async () => {
    try {
      const response = await getLookups("BillDetails");
      const lookups = response?.data?.data || [];
      // Filter active items with non-null values and map to value field
      const activeValues = lookups
        .filter((item) => item.value)
        .map((item) => item.value);
      setBillDetailsLookups(activeValues);
    } catch (error) {
      console.error("Error fetching bill details lookups:", error);
    }
  };

  const handleSelectDetailFromModal = (detailText) => {
    updateEditableContent(detailText);
  };

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);

    const parameters = {
      documentType: "Posting",
      matterId: matterRef?.matterId || "",
      nominalRef: nominalVatValue.nominalRef.nominalRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
  };

  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  const updateEditableContent = (text) => {
    if (!editableRef.current) return;

    editableRef.current.textContent = text;
    editableRef.current.focus();

    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(editableRef.current);
    range.collapse(false);
    sel?.removeAllRanges();
    sel?.addRange(range);
    setDetails(text);
  };

  return (
    <div className="h-100 d-flex">
      <div
        className="bgForm h-100 ms-2 pt-4 d-flex justify-content-center align-item-center"
        style={{
          minWidth: "350px",
          maxWidth: "350px",
          overflow: "auto",
        }}>
        <Form
          ignoreModified={true}
          onSubmit={handleSubmit}
          initialValues={initialData}
          id={formId}
          key={JSON.stringify(initialData)}
          render={(formRenderProps) => {
            return (
              <div className="w-100 px-3">
                <FormElement id={formId} name={formId} noValidate>
                  <fieldset>
                    <div className="mb-3">
                      <Label className="label">Matter Ref</Label>
                      <div
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                        }}>
                        <MattersCombobox
                          onChangematter={onChangematter}
                          value={
                            PRE_SELECTED_MATTER || POST_BILLING_REQUEST
                              ? matterRef
                              : undefined
                          }
                          disabled={!!(PRE_SELECTED_MATTER || POST_BILLING_REQUEST)}
                          error={error && !matterRef}
                          style={{
                            width: "100%",
                          }}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <Label className="label">Date</Label>
                      <div
                        style={{
                          borderRadius: "15px",
                          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                        }}>
                        <DatePicker
                          className={`px-2 ${styles["datePicker-bill"]}`}
                          value={dateselector}
                          toggleButton={CalenderCustomToggleButton}
                          onChange={onChangedateselect}
                        />
                      </div>
                    </div>

                    {props.component !== "BillingRequest" && (
                      <div className="mb-3">
                        <Label className="label">Reference</Label>
                        <Input
                          style={{
                            borderRadius: "10px",
                            boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                            paddingRight: "2%",
                            border:
                              error && reference === ""
                                ? "1px solid red"
                                : undefined,
                          }}
                          width={200}
                          value={reference}
                          placeholder="Reference"
                          onChange={(e) => {
                            setReference(e.target.value);
                          }}
                          className="px-3"
                        />
                      </div>
                    )}

                    <div className="mb-3">
                      <SearchComboBox
                        name="feeEarnerRef"
                        cbType={CONSTANT.FE}
                        placeholder="Fee earner"
                        customCombo={true}
                        width="auto"
                        value={feeEarner}
                        boxShadow={true}
                        className="px-2"
                        onChangeFunction={onChangeFeeEarner}
                        error={error && !feeEarner}
                      />
                    </div>

                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-end">
                        <Label className="label">Details</Label>
                        <Button
                          className="rounded-5"
                          style={{
                            background: "transparent",
                            border: "1px solid #d1d1d1",
                            cursor: "pointer",
                            height: "25px",
                            width: "25px",
                            marginBottom: "0.2rem",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            setShowBillDetailsModal(true);
                          }}
                          title="Manage pre-defined bill details">
                          <IoMenu
                            size={16}
                            style={{ marginBottom: "2px" }}
                            color="#666"
                          />
                        </Button>
                      </div>

                      <div style={{ position: "relative" }}>
                        <div
                          className={styles["details-editable-container"]}
                          style={{
                            border:
                              error && isBlank(details)
                                ? "1px solid red"
                                : undefined,
                          }}>
                          <div className={styles["details-buttons-float"]}>
                            {details && (
                              <Button
                                className={styles["details-textarea-btn"]}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDetails("");
                                  updateEditableContent("");
                                }}
                                title="Clear details">
                                <IoClose size={16} color="#666" />
                              </Button>
                            )}
                            <Button
                              className={`${styles["details-textarea-btn"]} bill-details-dropdown-button`}
                              onClick={(e) => {
                                e.preventDefault();
                                setShowDetailsDropdown(!showDetailsDropdown);
                              }}
                              title="Select from pre-defined details">
                              <BiSolidDownArrow size={10} color="#666" />
                            </Button>
                          </div>
                          <div
                            ref={editableRef}
                            className={styles["details-editable"]}
                            contentEditable
                            suppressContentEditableWarning
                            data-placeholder="Add Details or select from dropdown"
                            onInput={(e) => {
                              const value = e.currentTarget.textContent || "";

                              if (value.length <= 1000) {
                                setDetails(value);
                              } else {
                                toast.error("Details cannot exceed 1000 characters");
                                updateEditableContent(details);
                              }
                            }}
                          />
                        </div>
                        {showDetailsDropdown && billDetailsLookups.length > 0 && (
                          <div
                            className={`${styles["details-dropdown"]} bill-details-dropdown`}>
                            {billDetailsLookups.map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  padding: "10px 15px",
                                  cursor: "pointer",
                                  borderBottom:
                                    index < billDetailsLookups.length - 1
                                      ? "1px solid #f0f0f0"
                                      : "none",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "#f5f5f5";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "white";
                                }}
                                onClick={(e) => {
                                  updateEditableContent(item);
                                  setShowDetailsDropdown(false);
                                }}>
                                {item && item.length > 70
                                  ? `${item.substring(0, 73)}...`
                                  : item}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col d-flex justify-content-end">
                      <DocumentsUpload
                        progress={progress}
                        filesData={filesData}
                        onFileRemove={onFileRemove}
                        onUpload={handleUpload}
                        type={"Bill"}
                        onError={() => {
                          const newFiles = filesData.splice(filesData.length, 1);
                          setFilesData([...newFiles]);
                        }}
                      />
                    </div>
                  </fieldset>
                </FormElement>
              </div>
            );
          }}
        />
      </div>

      <div className="flex-grow-1 overflow-auto  d-flex flex-column">
        {props.component !== "BillingRequest" && <TransactionPeriod />}

        <div className="w-100 mt-2 flex-grow-1 overflow-auto">
          <div className="h-100 overflow-auto w-100 px-3 d-flex flex-column">
            <ExpansionPanel
              style={{ display: !matches ? "none" : "", flexShrink: 0 }}
              title="Matter Details"
              expanded={materDetailsExpanded}
              disabled={isExpansionLoading}
              onAction={async () => {
                setIsExpansionLoading(true);
                const newExpandedState = !materDetailsExpanded;
                setMaterDetailsExpanded(newExpandedState);
                try {
                  await updateCurrentUserSettings([
                    {
                      key: USER_SETTING_MATTER_DETAILS_EXPANDED_KEY,
                      value: newExpandedState.toString(),
                    },
                  ]);
                } catch (error) {
                  console.error("Failed to save expansion state", error);
                }
                setIsExpansionLoading(false);
              }}
              className="rounded-3">
              <Reveal>
                {materDetailsExpanded && (
                  <ExpansionPanelContent>
                    <div className="d-flex gap-2 justify-content-between align-items-stretch">
                      <MatterDetails
                        matter={matterRef}
                        width={"100%"}
                        clear={matterBalanceClear}
                      />
                      <MatterAccount
                        mt="0px"
                        float="right"
                        component={"Bills"}
                        matterId={matterName}
                        clear={matterBalanceClear}
                      />
                    </div>
                  </ExpansionPanelContent>
                )}
              </Reveal>
            </ExpansionPanel>

            <div
              className="d-flex mt-xxl-2 justify-content-between pt-2"
              style={{ flexShrink: 0 }}>
              <div>
                <Button
                  className={`k-button fw-semibold fs-sm bgBtnSecondary me-2  ${styles["custom-button"]}`}
                  onClick={() => {
                    setshowForm(true);
                  }}
                  disabled={matterRef === null || loadingData}>
                  <span className="me-1 pb-1">
                    <IoIosAddCircle
                      style={{
                        marginBottom: "2px",
                      }}
                    />
                  </span>
                  <span className="pt-1">Select Time</span>
                </Button>
                <Button
                  className={`k-button fw-semibold fs-sm bgBtnSecondary me-2  ${styles["custom-button"]}`}
                  disabled={matterRef === null || loadingData}
                  onClick={() => {
                    setShowProfitGrid(true);
                  }}>
                  <span className="me-1 pb-1">
                    <IoIosAddCircle
                      style={{
                        marginBottom: "2px",
                      }}
                    />
                  </span>
                  <span className="pt-1"> Add Profit Cost</span>
                </Button>
                <Button
                  className={`k-button fw-semibold fs-sm bgBtnSecondary me-2  ${styles["custom-button"]}`}
                  disabled={matterRef === null || loadingData}
                  onClick={() => {
                    setShowTemplatesGrid(true);
                  }}>
                  <span className="me-1 pb-1">
                    <IoIosAddCircle
                      style={{
                        marginBottom: "2px",
                      }}
                    />
                  </span>
                  <span className="pt-1"> Select Fixed Fee</span>
                </Button>
              </div>
              <div>
                <Button
                  className={`k-button fw-semibold fs-sm bgBtnSecondary me-2  ${styles["custom-button-dark"]}`}
                  disabled={matterRef === null || loadingData}
                  onClick={() => {
                    setshowDisbForm(true);
                  }}>
                  <span className="me-1 pb-1">
                    <IoIosAddCircle
                      style={{
                        marginBottom: "2px",
                      }}
                    />
                  </span>
                  <span className="pt-1"> Select Disb.</span>
                </Button>
                <Button
                  className={`k-button fw-semibold fs-sm bgBtnSecondary me-2  ${styles["custom-button-dark"]}`}
                  disabled={matterRef === null || loadingData}
                  onClick={() => setShowExpenseGrid(true)}>
                  <span className="me-1 pb-1">
                    <IoIosAddCircle
                      style={{
                        marginBottom: "2px",
                      }}
                    />
                  </span>
                  <span className="pt-1"> Add Expense</span>
                </Button>
                <Button
                  className={`k-button fw-semibold fs-sm bgBtnSecondary me-2  ${styles["custom-button-dark"]}`}
                  disabled={matterRef === null || loadingData}
                  onClick={() => setAddNewDisb(true)}>
                  <span className="me-1 pb-1">
                    <IoIosAddCircle
                      style={{
                        marginBottom: "2px",
                      }}
                    />
                  </span>
                  <span className="pt-1"> New Disb</span>
                </Button>
                <Button className="bgBtnSecondary button-small">Bill All</Button>
              </div>
            </div>

            <div
              className="flex-grow-1 overflow-auto mt-3"
              style={{ position: "relative" }}>
              <BillGrid
                timeData={matterTimeRecords}
                disbData={matterDisbRecords}
                reset={resetGrd}
                updateTimeData={(data) => {
                  setMatterTimeRecords(data);
                }}
                updateDisbData={(data) => {
                  setMatterDisbRecords(data);
                }}
                changeTimeTotals={(value) => {
                  setTimeTotals(value);
                }}
                changeDisbTotals={(value) => {
                  setDisbTotals(value);
                }}
                changeExpenseTotals={(value) => {
                  setExpenseTotals(value);
                }}
                changeBillTimeData={(item) => {
                  setBillTimeData(item);
                }}
                changeBillDisbData={(item) => {
                  setBillDisbData(item);
                }}
              />
              {loadingData && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    zIndex: 1000,
                  }}>
                  <Loader themeColor="warning" size="large" type="pulsing" />
                </div>
              )}
            </div>

            <div className={`d-flex gap-2 mt-3 fs-sm ${styles["totals-scroll-row"]}`}>
              {[
                { label: "Time Total", net: timeTotals.totalAmount, vat: timeTotals.totalVat },
                { label: "Expenses Total", net: expenseTotals.totalAmount, vat: expenseTotals.totalVat },
                { label: "Disb. Total", net: disbTotals.totalAmount, vat: disbTotals.totalVat },
                { label: "Bill Total", net: totalValues.totalAmount, vat: totalValues.totalVat },
              ].map(({ label, net, vat }) => (
                <div
                  key={label}
                  className={`bg-white rounded rounded-3 ${styles["total-card"]}`}
                  style={{ border: "1px solid #d4d3d3" }}>
                  <div
                    className="d-flex justify-content-between align-items-start mb-1 w-100 py-1 px-2 border-bottom border-black"
                    style={{
                      backgroundColor: "#F8F8F8",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                    }}>
                    <div className="fw-bold text-nowrap">{label}</div>
                    <div className="d-flex flex-column align-items-end ms-2">
                      <div className="fs-md fw-bold text-nowrap">{AmountFormat(net + vat)}</div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between gap-0">
                    <div
                      className="d-flex flex-column align-items-end flex-fill px-2 py-1"
                      style={{ borderRight: "1px solid #d1d1d1" }}>
                      <div className={`${styles["font-small"]}`}>Net</div>
                      <div className="fs-md text-nowrap">{AmountFormat(net)}</div>
                    </div>
                    <div className="d-flex flex-column align-items-end flex-fill px-2 py-1">
                      <div className={`${styles["font-small"]}`}>VAT</div>
                      <div className="fs-md text-nowrap">{AmountFormat(vat)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div
              className={` mb-3 mt-2 d-flex justify-content-between align-items-center right-align shadow-sm ${styles["action-bar"]}`}
              style={{ minHeight: "50px", flexShrink: 0 }}>
              <div className="d-flex gap-2 ms-3">
                <Button
                  className={"bgBtnSecondary p-2 rounded-2"}
                  disabled={isSubmitting || !matterRef}
                  onClick={() => setShowBillSettingsDialog(true)}>
                  <img src={SettingsIcon} alt="Settings" width={20} height={20} />
                </Button>
                <Button
                  className={"bgBtnSecondary p-2 rounded-2"}
                  disabled={isSubmitting || !matterRef}
                  onClick={() => setReportPreviewData(preparePostingData()[0])}>
                  <img src={PrinterIcon} alt="Preview" />
                </Button>
              </div>
              <div className="d-flex gap-2 me-3">
                {POST_BILLING_REQUEST && (
                  <Button
                    onClick={() => setRejectBillingRequestDialog(true)}
                    disabled={isSubmitting}
                    className="common-btn bgBtnSecondary"
                    type="">
                    Reject
                  </Button>
                )}
                <Button
                  className="common-btn bgBtnSecondary"
                  type=""
                  onClick={() => {
                    if (props.isDialog) props.onClose();
                  }}>
                  Cancel
                </Button>
                <SubmitButton
                  type="submit"
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                  form={formId}>
                  {props.component === "BillingRequest" ? "Submit Request" : "Post"}
                </SubmitButton>
              </div>
            </div>
          </div>

          {showDisbForm && (
            <MattersDisbRecords
              cancelEdit={() => {
                setshowDisbForm(false);
              }}
              matter={matterRef}
              changeMatterDisbList={(data) => {
                setMatterDisbRecords([...matterDisbRecords, ...data]);
              }}
            />
          )}
          {showForm && (
            <MattersTimeRecords
              changeMatterList={(data) => {
                setMatterTimeRecords([...matterTimeRecords, ...data]);
              }}
              addNominalVatInfo={(item) => {
                setNominalVatValue(item);
              }}
              cancelEdit={() => {
                setshowForm(false);
              }}
              matterId={matterRef?.matterId}
              defaultValues={matterDefaults}
              existingRecords={matterTimeRecords}
            />
          )}
          {showTemplatesGrid && (
            <BillFixedHeadersGrid
              changeMatterList={(data) => {
                setMatterTimeRecords([...matterTimeRecords, ...data]);
              }}
              addNominalVatInfo={(item) => {
                setNominalVatValue(item);
              }}
              cancelEdit={() => {
                setShowTemplatesGrid(false);
              }}
              matterId={matterRef?.matterId}
              defaultValues={matterDefaults}
            />
          )}

          {shoWProfitGrid && (
            <BillProfitCostGrid
              profitCostGrid={shoWProfitGrid}
              defaultValues={matterDefaults}
              changeMatterList={(data) => {
                setMatterTimeRecords([...matterTimeRecords, ...data]);
              }}
              matterId={matterRef?.matterId}
              cancelEdit={() => {
                setShowProfitGrid(false);
              }}
            />
          )}

          {showExpenseGrid && (
            <BillExpenseGrid
              profitCostGrid={showExpenseGrid}
              defaultValues={matterDefaults}
              changeMatterList={(data) => {
                setMatterDisbRecords([...matterDisbRecords, ...data]);
              }}
              matterId={matterRef?.matterId}
              cancelEdit={() => {
                setShowExpenseGrid(false);
              }}
            />
          )}

          {addNewDisb && (
            <QuickPostings
              onClose={() => setAddNewDisb(false)}
              postingCode={"DUU"}
              defaultMatter={matterRef}
              onSubmit={(data) => setMatterDisbRecords([...matterDisbRecords, data])}
              defaultValues={matterDefaults}
            />
          )}

          {reportPreviewData && (
            <Dialog
              title={"Billing Preview"}
              className="dialog-lg"
              onClose={() => setReportPreviewData(false)}>
              <div className="px-4 w-100 h-100 pb-2">
                <ReportViewer
                  modalHeight={"100%"}
                  name={(() => {
                    const resourceId =
                      selectedBillReportResourceId ??
                      matterDefaults?.defaultBillResourceId;
                    if (!resourceId || resourceId === GUID_EMPTY)
                      return "Templates\\BillTemplate.trdp";
                    return `${resourceId}.trdp`;
                  })()}
                  matterID={props?.matterId}
                  url={`${ReportURL}/Reporting/reports`}
                  saveActivity={true}
                  parameters={{
                    BillDataSource: JSON.stringify(reportPreviewData),
                  }}
                  shouldLoad={shouldLoad}
                  setShouldLoad={setShouldLoad}
                />
              </div>

              <DialogActionsBar>
                <div className="dialog-footer w-100">
                  <Button
                    className="common-btn bgBtnSecondary me-2"
                    onClick={() => setReportPreviewData(false)}>
                    Close
                  </Button>
                </div>
              </DialogActionsBar>
            </Dialog>
          )}
          {showBillSettingsDialog && (
            <BillSettingsDialog
              open={showBillSettingsDialog}
              onClose={() => setShowBillSettingsDialog(false)}
              matterId={matterRef?.matterId}
              matterDefaults={matterDefaults}
              onSaved={(updates) => {
                const defaultId = updates?.defaultBillResourceId;
                const matterBillId = updates?.matterBillResourceId;
                const isEmpty = (v) => v == null || v === GUID_EMPTY;
                const id = defaultId !== undefined ? defaultId : matterBillId;
                setSelectedBillReportResourceId(id !== undefined ? id : null);
                if (defaultId !== undefined) {
                  setMatterDefaults((prev) => ({
                    ...(prev || {}),
                    defaultBillResourceId: isEmpty(defaultId)
                      ? undefined
                      : defaultId,
                  }));
                  getMatterDefaultsData(matterRef?.matterId);
                }
              }}
            />
          )}
        </div>

        {rejectBillingRequestDialog && (
          <ConfirmationDialog
            content={`Are you sure you want to reject billing request?`}
            onClickYes={async () => {
              await onRejectBill();
              setRejectBillingRequestDialog(false);
            }}
            onClickNo={() => setRejectBillingRequestDialog(false)}
            onClose={() => setRejectBillingRequestDialog(false)}
          />
        )}

        {showBillDetailsModal && (
          <BillDetailsModal
            onClose={() => {
              setShowBillDetailsModal(false);
              fetchBillDetailsLookups();
            }}
            onSelectDetail={handleSelectDetailFromModal}
          />
        )}
      </div>
    </div>
  );
};
export default Bills;
